import React from 'react'
import { LeaseAuditController } from '../../../hooks/documentAudit/useLeaseAudit'
import {
    Modal,
    Typography,
    Slide,
    Paper,
    Theme,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@material-ui/core'
import { Container } from '../../../components'
import CloseIcon from '@material-ui/icons/Close'
import { getEntityClassDisplayName } from '../../../models/DocumentAudit/services'

interface Props {
    selectedDocOccuranceId: number
    onClose: () => void
    theme: Theme
    leaseAuditController: LeaseAuditController
}
export const LeasePageDocumentDetail = (props: Props) => {
    const {
        selectedDocOccuranceId,
        onClose,
        theme,
        leaseAuditController,
    } = props

    const documents = leaseAuditController.leaseDocumentOccurances || []

    const selectedDocument = documents?.find(
        (doc) => doc.id === selectedDocOccuranceId,
    )
    console.log(selectedDocument)
    const open = selectedDocOccuranceId !== -1 && selectedDocument !== undefined

    return (
        <Modal
            open={open}
            onClose={onClose}
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Slide direction="up" in={open}>
                <Paper>
                    <Container
                        style={{
                            height: 'calc(100vh - 200px)',
                            width: 'calc(100vw - 200px)',
                            display: 'flex',
                            overflow: 'hidden',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                            flexDirection: 'column',
                            flex: 1,
                        }}
                    >
                        {/* header */}
                        <Container
                            style={{
                                flexDirection: 'row',
                                flex: 1,
                                width: 'calc(100vw - 200px)',
                                padding: theme.spacing(2),
                                borderBottom: `1px solid ${theme.palette.divider}`,
                                minHeight: 60,
                                maxHeight: 60,
                                position: 'relative',
                            }}
                        >
                            {/* summary */}
                            <Container
                                style={{
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <div>
                                    <Typography variant="body2">
                                        Id:{' '}
                                        <strong>
                                            {selectedDocument?.document.id}
                                        </strong>
                                    </Typography>
                                    <Typography variant="body2">
                                        File Name:{' '}
                                        <strong>
                                            {
                                                selectedDocument?.document
                                                    .file_name
                                            }
                                        </strong>
                                    </Typography>
                                </div>
                            </Container>

                            {/* close button */}
                            <Container
                                style={{
                                    position: 'absolute',
                                    right: 16,
                                    top: 16,
                                    justifyContent: 'flex-end',
                                    alignItems: 'center',
                                    padding: 0,
                                }}
                            >
                                <IconButton onClick={onClose}>
                                    <CloseIcon />
                                </IconButton>
                            </Container>
                        </Container>

                        {/* body */}
                        <Container
                            style={{
                                flex: 1,
                                flexDirection: 'row',
                                height: '100%',
                            }}
                        >
                            {/* PDF Viewer */}
                            <Container style={{ flex: 1, height: '100%' }}>
                                {selectedDocument && (
                                    <div style={{ flex: 1 }}>
                                        <iframe
                                            key={`PDF-${selectedDocument.id}`}
                                            id="pdf-viewer"
                                            width="100%"
                                            height="100%"
                                            loading="lazy"
                                            src={`${selectedDocument.document.file}`}
                                        />
                                    </div>
                                )}
                            </Container>
                            {/* Entity Values */}
                            <Container
                                style={{
                                    height: '100%',
                                    padding: 24,
                                    alignSelf: 'flex-start',
                                    marginLeft: 'auto',
                                    minWidth: 320,
                                }}
                            >
                                <TableContainer>
                                    <Table size="small">
                                        <TableBody>
                                            {selectedDocument?.document.entity_values.map(
                                                (entityValue) => (
                                                    <TableRow
                                                        key={entityValue?.id}
                                                    >
                                                        <TableCell
                                                            style={{
                                                                fontSize: 18,
                                                            }}
                                                        >
                                                            {getEntityClassDisplayName(
                                                                entityValue
                                                                    ?.entity_alias
                                                                    .alias,
                                                            )}
                                                        </TableCell>
                                                        <TableCell
                                                            style={{
                                                                fontSize: 16,
                                                                fontWeight: 600,
                                                            }}
                                                        >
                                                            {entityValue?.value ||
                                                                ''}
                                                        </TableCell>
                                                    </TableRow>
                                                ),
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Container>
                        </Container>
                    </Container>
                </Paper>
            </Slide>
        </Modal>
    )
}
